import React, { useState } from "react"; // , { useState }
import { Form, Formik } from "formik";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  AntSelect,
  Select,
  CommonButton,
  Input as TextInput,
} from "../../../index";

function ManageReportedFilter({
  onReset,
  t,
  onSubmit,
  loading,
  reportCategory,
  reportCategoryLoader,
}) {
  const [disableReset, setDisableReset] = useState(true);
  const [disableSubmit, setDisableSubmit] = useState(false);

  let initialValues = {
    status: undefined,
    reportedBy: "",
    reportedCategory: undefined,
  };

  const arrayOfData = [
    { id: "all", name: "All" },
    {
      id: "active",
      name: "Active",
    },
    {
      id: "inactive",
      name: "Inactive",
    },
  ];

  const onHandleReset = (resetForm) => {
    resetForm({});
    setDisableReset(true);

    onReset();
  };

  return (
    <Formik
      initialValues={{ ...initialValues }}
      onSubmit={(val) => {
        if (disableSubmit) {
          onSubmit(val);
        }
      }}
      validate={(e) => {
        if (e.status || e.reportedBy || e.reportedCategory) {
          setDisableReset(false);
          setDisableSubmit(true);
        } else {
          setDisableReset(true);
          setDisableSubmit(false);
        }
      }}
    >
      {(props) => {
        return (
          <Form>
            <div className="dropdown-body dropdown-body-rg">
              <div className="row g-3">
                {/* <div className="col-md-6">
                  <label className="overline-title overline-title-alt">
                    Creator Name
                  </label>
                  <TextInput
                    className="form-control "
                    type="text"
                    placeholder="Enter creator name"
                    setFieldValue={props.handleChange}
                  />
                </div> */}
                {/* <div className="col-md-6">
                  <label className="overline-title overline-title-alt">
                    Phone No
                  </label>
                  <TextInput
                    className="form-control "
                    type="text"
                    name="phoneNumber"
                    placeholder="Enter phone no"
                    setFieldValue={props.handleChange}
                  />
                </div> */}
                <div className="col-md-6">
                  <div className="form-group ">
                    <label className="overline-title overline-title-alt">
                      Status
                    </label>
                    <AntSelect
                      size="medium"
                      id="status"
                      extraClassName="form-control"
                      name="status"
                      disabled={false}
                      variant="standard"
                      setFieldValue={props.handleChange}
                      placeholder="Select status"
                      arrayOfData={arrayOfData}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <label className="overline-title overline-title-alt">
                    Reported By
                  </label>
                  <TextInput
                    className="form-control "
                    type="text"
                    name="reportedBy"
                    placeholder="Reported by"
                    setFieldValue={props.handleChange}
                  />
                </div>
                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="overline-title overline-title-alt">
                      Report Category
                    </label>
                    <Select
                      placeholder="Select Category"
                      name="reportedCategory"
                      setFieldValue={props.handleChange}
                      loading={reportCategoryLoader}
                    >
                      {reportCategory?.map((category, index) => {
                        return (
                          <option key={index} value={category?.category}>
                            {category?.category}
                          </option>
                        );
                      })}
                    </Select>
                  </div>
                </div>
              </div>
            </div>
            <div className="dropdown-foot between">
              <Link
                to="#"
                type="button"
                className="clickable"
                onClick={(e) => {
                  e.preventDefault();
                  if (!disableReset) {
                    onHandleReset(props.resetForm);
                  }
                }}
              >
                {t("text.common.reset")}
              </Link>

              <CommonButton
                extraClassName="btn btn-sm btn-primary"
                htmlType="submit"
                loading={loading}
                type="submit"
              >
                {t("text.common.filter")}
              </CommonButton>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

export default withTranslation()(ManageReportedFilter);
